export class TimeSlotFormFieldKeys {
  constructor() {
    return {
      sameDay: false,
      startDate: null,
      endDate: null,
      splitDayInTwoHalfs: false,
      startTimeFirstHalfDay: '',
      endTimeFirstHalfDay: '',
      startTimeSecondHalfDay: '',
      endTimeSecondHalfDay: '',
      availability: null,
      duration: 5,
      allowedTestTypes: []
    };
  }
}
